import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LeadDetailPanelComponent } from './lead-detail-panel.component';

const routes: Routes = [{ path: '', component: LeadDetailPanelComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LeadDetailPanelRoutingModule { }
